import React, { FC, useState } from 'react';
import { useParams, usePathname } from 'next/navigation';
import { Configure, useHits } from 'react-instantsearch-hooks-web';
import { mapProduct } from 'helpers/algolia/map-product';
import ProductTiles from '../product-tile/tile';
import Typography from 'components/commercetools-ui/atoms/typography';
import { isPdpUrl } from 'helpers/utils/pdpUrlHelper';
export type ProductListCMSProps = {
  data?: any;
  innerArrows?: boolean;
  solidArrows?: boolean;
  isSearchResult?: boolean;
  disableWishlistButton?: boolean;
};
const ProductListCMS: FC<ProductListCMSProps> = ({
  data,
}) => {
  const [productsDisplayed, setProductsDisplayed] = useState<number>(4);
  const { locale } = useParams();
  const { hits } = useHits();

  const sectionIndices = Array.from({ length: 10 }, (_, index) => index);
  let rawSkuCodes = null;
 
  for (let i = 0; i < sectionIndices.length; i++) {
    const sectionProduct = data?.sections?.[sectionIndices[i]]?.commercetools_product?.sku_code;
  if (sectionProduct) {
    rawSkuCodes = sectionProduct;
    break;
  }
  }
  const skuCodes = rawSkuCodes
    .match(/<p>(.*?)<\/p>/g)
    .map((code: string) => code.replace(/<\/?p>/g, '').trim());
  const noProductsFound = skuCodes.length === 0;
  const getFilterQuery = (skus: string[]) => {
    return skus.map(sku => `variants.searchableAttributes.item-code:'${sku}'`).join(' OR ');
  };
  
  const currentURL = usePathname();
  const isProductDetailPage = isPdpUrl(currentURL);
  const mappedProducts = hits
    .map((hit: any) => {
      const matchedSku = skuCodes.find((code: any) =>
        hit.variants.some((variant: any) => variant.attributes['item-code'] === code)
      );
      if (!matchedSku) {
        return null; 
      }
      return mapProduct(hit, locale, matchedSku);
    })
    .filter((product: any) => product !== null);
  const sortedProducts = mappedProducts.slice().sort((productA: any, productB: any) => {
    const itemCodeA = productA.productcode || '';
    const itemCodeB = productB.productcode || '';
    const indexA = skuCodes.indexOf(itemCodeA);
    const indexB = skuCodes.indexOf(itemCodeB);
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
  });
  const handleShowMore = () => {
    setProductsDisplayed(sortedProducts.length);
  };
  return (
    <div
      id="related-products"
      className={`our-product-container py-48 px-24 xl:pb-80 2xl:pb-80 md:py-48 2xl:pt-48 ${
        isProductDetailPage
          ? 'relative left-full w-screen -translate-x-full bg-[#EDEDED] px-48 md:pb-1 md:pt-100 lg:grid lg:grid-cols-12 lg:pl-0 xl:pb-153 xl:pt-153'
          : 'md:px-48'
      }`}
    >
      {noProductsFound ? (
        <div className="">
        </div>
      ) : (
        <>
          <Configure query={''} filters={getFilterQuery(skuCodes)} hitsPerPage={48} facets={['*']} maxValuesPerFacet={999} 
            attributesToHighlight={[]} // Disable highlighting
            attributesToSnippet={[]} // Disable snippetting
            attributesToRetrieve={[
              "name",
              "slug",
              "categoryKeys",
              "masterVariantID",
              "searchableAttributes.IsNew",
              "variants.id",
              "variants.key",
              "variants.sku",
              "variants.images",
              "variants.attributes.colour",
              "variants.attributes.item-code",
              "variants.attributes.item-name",
            ]} 
          />
          <div className={isProductDetailPage ? 'lg:col-span-9 lg:col-start-4' : ''}>
            <div className="grid grid-cols-2 gap-8 w-[min(100%,47rem)] m-auto">
              {sortedProducts.slice(0, productsDisplayed).map((product: any, index: number) => (
                <div key={index}>
                  <ProductTiles key={index} images={product?.images} product={product} />
                </div>
              ))}
            </div>
            {sortedProducts.length > productsDisplayed && (
              <div className="text-center mt-4">
                <button className="text-white bg-[#2B2C39] px-25 py-13 mt-10" onClick={handleShowMore}>
                  Show all products
                </button>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};
export default ProductListCMS;